<template>
    <section>
        <div class="spacing-large space-between">
            <div>

                <h2>Option 2 Standalone with EPS fallback</h2>

                <p>With Standalone (SA) Option 2, the 5G core is introduced into the network, including several elements not required in Option 3X.</p>
                <p>This solution implements EPS fallback, which forces a device to move from 5G to 4G LTE during voice call set-up. After EPS Fallback, IMS voice and data traffic ae carried by the existing LTE network while the call is active.</p>

            </div>
            <div>

                <infobutton>
                    The advantage of this solution for initial deployments is that it supports 5G SA handsets to enhance the device battery life.
                </infobutton>

                <div class="info-wrapper">
                    <infobutton :type="'disadvantage'">
                        This disadvantage of this solution is the lower bandwidth of 4G that the user experiences during fallback as their dual radio handset turns off the 5G radio and uses the 4G radio. Call Setup Time is also longer than with VoLTE (+1 sec).
                    </infobutton>
                </div>

            </div>
        </div>
        <div class="spacing-small center gray">

            <img src="~@/assets/images/chapter-3/architectural-evolution-4.png" alt="">

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    .info-wrapper {
        margin: 10px 0 30px;
    }

</style>